import { useAtomValue } from 'jotai'
import React from 'react'
import * as R from 'remeda'

import { countColumnKeysAtom } from '../atoms'
import { type CountColumnKey } from '../utils'

export const useMapCountColumnKey = () => {
  const countColumnKeys = useAtomValue(countColumnKeysAtom)

  return React.useCallback(
    <T>(mapFunc: (countColumnKey: CountColumnKey) => T) =>
      R.mapToObj(countColumnKeys, (countColumnKey) => [
        countColumnKey,
        mapFunc(countColumnKey),
      ]),
    [countColumnKeys],
  )
}
